import styles from "./index.module.css";
import c2cToken from "assets/svg/c2c-token.svg";
import ton from "assets/svg/tonkeeper.svg";
import { Skeleton } from "antd";
import "antd/dist/reset.css";

type Props = {
  iban: string;
  wallet: string;
  balance_eur: string;
  balance_tokens: string;
  balance_tons: string;
  isCryptoBaseLoading: boolean;
};
export const CryptoInfo = (props: Props) => {
  if (props.isCryptoBaseLoading) {
    return (
      <div className={styles.container}>
        <Skeleton active paragraph={{ rows: 3 }} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.infoAddressWrapper}>
        <div className={styles.infoAddress}>
          <div>IBAN</div>
          <div>{props?.iban ? `${props.iban.slice(0, 4)}...${props.iban.slice(-4)}` : "—"}</div>
        </div>
        <div className={styles.infoAddress}>
          <div>Wallet</div>
          <div>
            {props.wallet.slice(0, 4)}...{props.wallet.slice(-4)}
          </div>
        </div>
      </div>
      <div className={styles.cryptoBalanceWrapper}>
        <div>Current Balance</div>
        <div className={styles.cryptoBalance}>
          <div>€{props.balance_eur}</div>
          <div>
            <img src={c2cToken} alt="C2C Token" />
            <div>{props.balance_tokens}</div>
          </div>
          <div>
            <img src={ton} alt="ton" />
            <div>{props.balance_tons}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
